import React from 'react';
import { Grid, Typography, Container } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container>
      <Grid container spacing={3} sx={{ marginTop: 4 }}>
        <Grid item xs={12}>
          <Typography variant="h4" component="h1" gutterBottom>
            Freshsweeper Privacy Policy
          </Typography>
          {/* <Typography variant="body1" color="textSecondary" paragraph>
            Effective Date: [Insert Date]
          </Typography> */}
          <Typography variant="body1" paragraph>
            Freshsweeper (“we,” “our,” or “us”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our cleaning services application (“App”). Please read this policy carefully to understand our practices regarding your personal information.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" component="h2" gutterBottom>
            1. Information We Collect
          </Typography>
          <Typography variant="body1" paragraph>
            We collect various types of information to provide and improve our services:
          </Typography>
          <Typography variant="body1" paragraph sx={{ marginLeft: 2 }}>
            a. Personal Information
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 4 }}>
            • Name
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 4 }}>
            • Email address
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 4 }}>
            • Phone number
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 4 }}>
            • Payment details (processed securely via a third-party payment gateway)
          </Typography>
          <Typography variant="body1" paragraph sx={{ marginLeft: 2 }}>
            b. Property Information
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 4 }}>
            • Address of the property
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 4 }}>
            • Number of rooms, bathrooms, and other property details
          </Typography>
          <Typography variant="body1" paragraph sx={{ marginLeft: 2 }}>
            c. Location Information
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 4 }}>
            • We may collect location data to match you with nearby cleaners or cleaning jobs (with your explicit consent).
          </Typography>
          <Typography variant="body1" paragraph sx={{ marginLeft: 2 }}>
            d. Device Information
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 4 }}>
            • Device name
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 4 }}>
            • Operating system version
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 4 }}>
            • App usage data
          </Typography>
          <Typography variant="body1" paragraph sx={{ marginLeft: 2 }}>
            e. Photos
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 4 }}>
            • Before and after cleaning task photos (uploaded by cleaners or hosts for task verification).
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" component="h2" gutterBottom>
            2. How We Use Your Information
          </Typography>
          <Typography variant="body1" paragraph>
            We use your information for the following purposes:
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            • To match hosts with cleaners based on proximity and preferences.
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            • To facilitate bookings and schedule cleaning services.
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            • To process payments securely.
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            • To send notifications, updates, and reminders.
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            • To enhance user experience through feedback and data analytics.
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            • To comply with legal obligations or resolve disputes.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" component="h2" gutterBottom>
            3. How We Share Your Information
          </Typography>
          <Typography variant="body1" paragraph>
            We may share your information in the following circumstances:
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            • With Cleaners or Hosts: To facilitate cleaning requests and tasks.
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            • With Service Providers: For payment processing, notifications, and analytics.
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            • Legal Requirements: If required by law, court order, or legal process.
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            • Business Transfers: In the event of a merger, sale, or acquisition.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" component="h2" gutterBottom>
            4. Data Retention
          </Typography>
          <Typography variant="body1" paragraph>
            We retain your information for as long as necessary to fulfill the purposes outlined in this policy unless a longer retention period is required or permitted by law.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" component="h2" gutterBottom>
            5. Data Security
          </Typography>
          <Typography variant="body1" paragraph>
            We implement reasonable security measures to protect your information from unauthorized access, use, or disclosure. However, no internet-based application is completely secure, and we cannot guarantee absolute security.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" component="h2" gutterBottom>
            6. Your Rights
          </Typography>
          <Typography variant="body1" paragraph>
            You have the following rights regarding your data:
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            • Access, correct, or delete your personal information.
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            • Opt-out of receiving marketing communications.
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            • Withdraw consent for data collection (where applicable).
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            • File a complaint with a data protection authority.
          </Typography>
          <Typography variant="body1" paragraph sx={{ marginLeft: 2 }}>
            To exercise these rights, contact us at [Insert Contact Email].
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" component="h2" gutterBottom>
            7. Third-Party Services
          </Typography>
          <Typography variant="body1" paragraph>
            Our App may include links to third-party websites or services. We are not responsible for the privacy practices of these third parties. Please review their privacy policies before sharing your information.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" component="h2" gutterBottom>
            8. Children’s Privacy
          </Typography>
          <Typography variant="body1" paragraph>
            Our App is not intended for individuals under the age of 18. We do not knowingly collect personal information from children.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" component="h2" gutterBottom>
            9. Changes to This Policy
          </Typography>
          <Typography variant="body1" paragraph>
            We may update this Privacy Policy from time to time. Any changes will be effective upon posting the revised policy in the App. We encourage you to review this policy periodically.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" component="h2" gutterBottom>
            10. Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about this Privacy Policy, please contact us at:
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            Freshsweeper
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            Email: service@freshsweeper.com
          </Typography>
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            Phone: +1 973 380 4757
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

export default PrivacyPolicy;